!function() { //run once on launch
console.log("A11yPro beta: loading")
	let doc = document;
	let script = doc.querySelector('#apscript').dataset; //script element
	let url = doc.currentScript.src;
	apS = { //settings
		loc: url.substring(0, url.lastIndexOf('/') + 1),
		btxt: {
			DE: {
				t: "Menü Eingabehilfe",
				s: "Zum Inhalt springen"
			},
			EN: {
				t: "Accessibility menu",
				s: "Skip to content"
			},
			ES: {
				t: "Menú de accesibilidad",
				s: "Pasar al contenido"
			},
			FR: {
				t: "Menu accessibilité",
				s: "Aller au contenu"
			},
			IT: {
				t: "Menu Accessibilità",
				s: "Vai al contenuto"
			},
			NL: {
				t: "Toegankelijk-heid menu",
				s: "Ga naar de inhoud"
			},
			PT: {
				t: "Menu de acessibilidade",
				s: "Ir para o conteúdo"
			},
			AR: {
				t: "قائمة إمكانية الوصول",
				s: "انتقل إلى المحتوى"
			},
			HE: {
				t: "תפריט נגישות",
				s: "דלג לתוכן"
			},
			HI: {
				t: "एक्सेसिबिलिटी मेनू",
				s: "इसे छोड़कर सामग्री पर जाएँ "
			}
		},
		btn: {
			m: {
				style: script.mobistyle, //default: 1,
				side: script.mobiside, //default: 'left',
				x: script.mobix, //default: '10px',
				y: script.mobiy, //default: '10px',
				size: script.mobisize, //default: 1, //size on mobile
				hide: +script.mobihide, //default: 0,
			},
			d: {
				style: script.deskstyle, //default: 1,
				text: +script.desktext, //default: 1,
				side: script.deskside, //default: 'left',
				x: script.deskx, //default: '20px',
				y: script.desky, //default: '20px',
				size: script.desksize, //default: 1, //size on desktop
				hide: +script.deskhide, //default: 0,
			},
			ico: script.ico,
			anim: script.anim, //move animation to attribute??
		},
		col: {
			b1: script.bgc1, //default: '605DC0',
			t1: script.tc1, //default: 'fff',
		},
		css: decodeURIComponent(script.css), //custom CSS attribute, URI encoded
	};

	let mobiSide = apS.btn.m.side;
	let deskSide = apS.btn.d.side;
	let deskStyle = apS.btn.d.style;
	let langs = Object.keys(apS.btxt);
	apV = { //variables
		btn: {
			m: {
				r: mobiSide == 'right' ? apS.btn.m.x : 'auto', //button inset right if right : left
				l: mobiSide == 'left' ? apS.btn.m.x : 'auto', //button inset left if left : right
				rad: mobiSide == 'left' ? '0 50% 50% 0' : '50% 0 0 50%', //Style 2 button radius if left : right
			},
			d: {
				r: deskSide == 'right' ? apS.btn.d.x : 'auto', //button inset right if right : left
				l: deskSide == 'left' ? apS.btn.d.x : 'auto', //button inset left if left : right
				rad: deskSide == 'left' ? '0 50% 50% 0' : '50% 0 0 50%', //Style 2 button radius if left : right
				sm: deskStyle == 1 ? '0' : deskSide == 'left' ? '0 0 0 -6px' : '0 -4px 0 0', //Style 2 desktop: svg margin if left : right
				tm: deskStyle == 1 || deskSide == 'left' ? '-11px 0 0' : '-11px -15px 0 -11px' //Desktop: style 1, 2: text margin if left : right
			},
		},
		lang: {
			iLang: (langs.indexOf(doc.documentElement.lang.substring(0, 2).toUpperCase()) + 1 || (typeof Shopify !== "undefined" && langs.indexOf(Shopify?.locale.toUpperCase())) + 1 || 2) - 1, //initial lang variable, chosen as follows: 1. Page language, if supported. 2. Shopify locale if exists and is supported 3. English (index of 1, so chosen by (math) 2-1). The plus 1 is in case the page or locale language is not supported they would return -1, which is truthy. By adding 1 to the result, we get 0 if the language is unsupported (falsy). We then subtract 1 from the truthy result to get the actual index of the language.
		},
	};
	//let c = doc.cookie.replace(/(?:(?:^|.*;\s*)ap@lang\s*\=\s*([^;]*).*$)|^.*$/, "$1"); //cookie lang - if no cookie: ""
	//apV.lang.i = /*c ? +c : /*apV.lang.iLang !== -1 ?*/ apV.lang.iLang //: 0; //index of current lang in oK, derived as follows: if there's a cookie, use that. Else use page language if supported, else use shopify locale, else use English (0)
	apV.lang.c = langs[apV.lang.iLang]; //current lang (2 letter code)

	addEventListener("hashchange", apHash);

	doc.addEventListener("keydown", e => e.altKey && e.code == "KeyA" && apBtn());

	apCBtn();
}();


function apCBtn() { //create button
	let doc = document;
	[...doc.querySelectorAll('.aphb, #ap')].map(e => e.remove());
	let mobiStyleIs1 = apS.btn.m.style == 1; 
	let deskStyleIs1 = apS.btn.d.style == 1;
	let deskSide = apS.btn.d.side;
	let mobiSide = apS.btn.m.side;
	let deskText = apS.btn.d.text;
	let deskRadius = deskStyleIs1 ? deskText ? '25%' : '50%' : apV.btn.d.rad;
	let textColor1 = apS.col.t1;
	let afterBegin = "afterbegin";
	let currentLang = apV.lang.c;
	let ttl = apS.btxt[apV.lang.c].t;
	let deskHeightInteger = parseInt(apS.btn.d.y); //number in the height on desktop
	doc.body.insertAdjacentHTML((apS.btn.d.y.includes("%") && deskHeightInteger > 50) || deskHeightInteger > innerHeight/2 ? afterBegin : "beforeend", //if height on desktop is a percentage and position is in the top half of the screen, add the button to the top of the dom. Otherwise, to the end of the dom. If it's in px, if it's higher than 50% of window innerHeight then to the top of the dom
		`<button id="ap" onclick="apBtn()" aria-label="${ttl}" aria-haspopup="true" lang="${currentLang}">${apS.btn.ico}${deskText ? '<span class="apmbtntxt" aria-hidden="true">ALT+A</span>' : ''}<style>
		button.aphb, button.aphb kbd, #ap span.apmbtntxt {
			font-family: Arial !important;
		}
		button.aphb, button#ap {
			position: fixed;
			box-shadow: gray 0 4px 7px;
			background-color: #${apS.col.b1};
			z-index: 2147483645;
			text-decoration: 0;
			cursor: pointer;
			justify-content: center;
			align-items: center;
			border: 0;
			overflow: hidden;
			padding: 1px 6px;
		}

		button.aphb {
			left: -700px;
			transition: left 0.5s;
			font-size: 30px;
			color: #${textColor1};
			border-radius: 14px;
			top: 25px;
			padding: 5px 10px;
			border: 2px solid #${textColor1};
			gap: 9px;
			display: flex;
		}
		button#ap svg {
			fill: #${textColor1};
		}
		button.aphb kbd, #apalert kbd {
			/*display: inline-block;*/
			border: 4px solid gray;
			border-radius: 7px;
			background: #fff;
			padding: 4px 7px;
			font-size: 25px;
			color: #000;
			vertical-align: middle;
		}
		button.aphb:focus {
			left: 25px;
			outline: 0;
		}
		@media (forced-colors: active) and (prefers-color-scheme: light) { /*custom for windows high contrast mode light color theme*/
			button#ap svg {
				forced-color-adjust: none;
				filter: invert(1);
			}
		}

		button#ap:focus-visible, #ap2 .apheader *:focus-visible, #ap2 .apfooter *:focus-visible {
			outline-offset: 3px;
			box-shadow: 0 0 0 3px #fff;
			outline: 2px solid #B60000;
		}

		@keyframes apspin {
			100% {
				transform: rotate(360deg);
			}
		}
		@keyframes apslide {
			49% {
				opacity: 1;
				transform: translateX(130%);
			}
			50% {
				opacity: 0;
			}
			51% {
				transform: translateX(-130%);
			}
			52% {
				opacity: 1;
			}
		}

		@media (max-width: 749px) {
			button#ap {
				display: ${apS.btn.m.hide ? 'none' : 'grid'};
				inset: auto ${mobiStyleIs1 ? apV.btn.m.r : mobiSide == 'right' ? '0px' : apV.btn.m.r} ${apS.btn.m.y} ${mobiStyleIs1 ? apV.btn.m.l : 0};
				scale: ${apS.btn.m.size};
				transform-origin: bottom ${mobiSide};
				border-radius: ${mobiStyleIs1 ? '50%' : apV.btn.m.rad};
				width:${mobiStyleIs1 ? '46px;height:46' : '36px;height:36'}px;
			}
			button#ap svg {
				width:${mobiStyleIs1 ? '41px;height:41' : '31px;height:31'}px;
			}
			.apmbtntxt {
				display: none;
			}
		}

		@media (min-width: 750px) {
			button#ap {
				box-shadow: gray 0 4px 24px;
				display: ${apS.btn.d.hide ? 'none' : 'grid'};
				inset: auto ${deskStyleIs1 ? apV.btn.d.r : deskSide == 'right' ? '-2px' : apV.btn.d.r} ${apS.btn.d.y} ${deskStyleIs1 ? apV.btn.d.l : '-2px'};
				scale: ${apS.btn.d.size};
				transform-origin: bottom ${deskSide};
				width: ${deskStyleIs1 ? deskText ? '64px;height:70' : '64px;height:64' : deskText ? '67px;height:73' : '55px;height:61'}px;
				border-radius: ${deskRadius};
				${(deskText && !deskStyleIs1) && `padding-${deskSide == 'left' ? 'right' : 'left'}:14px`}; /*padding to move button contents away from edge if hotkey text is shown, on style 2 on desktop*/
			}
			button#ap::before {
				border-radius: ${deskRadius};
				border: 2.5px solid #${textColor1};
				${!deskStyleIs1 && `border-${deskSide}:0`};
				content: '';
				position: absolute;
				inset: 0;
				scale: .94;
			}
			button#ap svg {
				margin: ${apV.btn.d.sm};
				${!deskStyleIs1 && "border-radius:50%"};
				width: 41px;
				height: 41px;
			}
			#ap span.apmbtntxt {
				color: #${textColor1};
				margin: ${apV.btn.d.tm};
				display: block;
				font-weight: 700;
				font-size: 13px;
			}
		}

		${apS.css}
		</style></button>`);

	//quick nav buttons
	//doc.querySelector('.skip-to-content-link')?.remove(); //if the theme already has a link to #maincontent (shop 2.0 schema), remove it. Replaced by:
	doc.querySelector('a[href="#MainContent"]')?.remove() //if the theme already has a link to #maincontent, remove it (but only the first one). This now works for shop 2.0 and older themes such as debut, as long as they use an a href and not a button.
	for (let i = 0; i < 2; i++) {
		doc.body.insertAdjacentHTML(afterBegin, `<button class="aphb" lang="${currentLang}" onclick="${i ? "apBtn()" : `location.href='#${(doc.querySelector('main') || doc.querySelector('article') || doc.querySelector('p') || "").id ?? 'apmain'}'`}"><kbd aria-hidden="true">ENTER ↵</kbd> ${i ? ttl : apS.btxt[currentLang].s}</button>`);
	}

	doc.cookie.split(";").filter((c) => c.trim().startsWith("ap@")).length && apLoad(() => apReadCookies()); //if there are cookies, payload

	apHash(); //checks if page loaded with a hash
}

function apHash() { //hash checker
	let loc = location;
	if (loc.hash == "#ap") {
		apBtn();
		loc.hash = ""; //remove hash
	} else if (loc.hash == "#apdec") {
		apBtn(1);
		loc.hash = "";
	}
}


function apBtn(v) { //button press handler
	if (document.querySelector('#ap2')) { //drawer already created
		//console.log("drawer exists")
		apV.drOpen ? apClose() : apOpen(v); //open/close drawer
	} else {
		//console.log("creating drawer")
		apV.pl ? apCreateDrawer(v) : apLoad(() => apCreateDrawer(v)); //payload
	}
}


function apLoad(callback) { //payload loader
	if (!apV.pl) { //unless it's already running (avoid duplication)
		let doc = document;
		let script = doc.createElement("script");
		script.src = apS.loc + `a11ypropl.js`; //no longer necessary due to cache control on server "?" + Date.now();
		doc.querySelector('#ap svg').style.animation = apS.btn.anim + ` 99`;
		doc.querySelector('#ap').setAttribute('aria-busy', 'true');
		script.onload = () => {
			callback();
			apV.pl = 1;
		};
		doc.head.appendChild(script);
	}
}